import React, { FC } from 'react';
import Navigation from 'evcharging/containers/layout/Navigation';
import Page from 'evcharging/components/Page';
import { createGetServerSideProps, StaticPageProps } from 'evcharging/app';
import Footer from 'evcharging/containers/layout/Footer';
import { I18nPage } from 'i18n/types/pages.enum';
import AboutUsHeader from 'containers/about-us/AboutUsHeader';
import WhatWeOffer from 'containers/about-us/WhatWeOffer';
import { getServices } from 'evcharging/services/cmsClient';
import { E5Service } from 'evcharging/services/types';
import ForItems from 'containers/about-us/ForItems';
import OurServices from 'containers/about-us/OurServices';
import OurCommitment from 'containers/about-us/OurCommitment';
import AtGlance from 'containers/about-us/AtGlance';

interface AboutUsProps extends StaticPageProps { services: E5Service[] }

const AboutUs: FC<AboutUsProps> = (props) => {
  const { page, services } = props;

  return (
    <Page
      locales={page.locales}
      title={page.meta_title}
      description={page.meta_description}
    >
      <Navigation hideSubNav />
      <AboutUsHeader />
      <WhatWeOffer services={services} />
      <ForItems />
      <OurServices />
      <OurCommitment />
      <AtGlance />
      <Footer />
    </Page>
  )
};

export const getServerSideProps = createGetServerSideProps(undefined, async (context, locale) => {
    return {
      services: await getServices(locale)
    }
  },
  [I18nPage.AboutUs, I18nPage.Home]
);

export default AboutUs;
